/**
 *  @swagger
 *  definitions:
 *    RegattaAdminParams:
 *      type: object
 *      properties:
 *        RegattaId:
 *          description: ID of the associated Regatta
 *          type: string
 *        AdminId:
 *          description: ID of the associated Admin
 *          type: string
 *
 *  @swagger
 *  definitions:
 *    RegattaAdminCreateParams:
 *      allOf:
 *        - $ref: '#/definitions/RegattaAdminParams'
 *        - type: object
 *          required:
 *            - RegattaId
 *            - AdminId
 *
 *  @swagger
 *  definitions:
 *    RegattaAdminQueryParams:
 *      allOf:
 *        - type: object
 *          properties:
 *            id:
 *              description: ID of the RegattaAdmin
 *              type: string
 *        - $ref: '#/definitions/RegattaAdminParams'
 *
 *  @swagger
 *  definitions:
 *    RegattaAdminUpdateParams:
 *      allOf:
 *        - $ref: '#/definitions/RegattaAdminQueryParams'
 *        - type: object
 *          required:
 *            - id
 *
 *  @swagger
 *  definitions:
 *    RegattaAdmin:
 *      allOf:
 *        - $ref: '#/definitions/RegattaAdminCreateParams'
 *        - $ref: '#/definitions/RegattaAdminUpdateParams'
 *        - $ref: '#/definitions/Timestamps'
 *
 *  @swagger
 *  components:
 *    schemas:
 *      RegattaAdmin:
 *        allOf:
 *          - $ref: '#/definitions/RegattaAdmin'
 *          - type: object
 *            properties:
 *              Regatta:
 *                description: Regatta of the RegattaAdmin
 *                $ref: '#/components/schemas/Regatta'
 *              Admin:
 *                description: Admin of the RegattaAdmin
 *                $ref: '#/components/schemas/Admin'
 */

// Types
import type {
  $Model,
  $ModelClass,
  $ModelClasses,
} from '.';
import type {
  $Field,
} from '../types';

export type $RelationIds = {
  AdminId: string;
  RegattaId: string;
};
export type $CreateParams = $RelationIds;

export type $UpdateParams = {
  id: string;
} & Partial<$CreateParams>;

export type $UpsertParams = $CreateParams & {
  id?: string;
};

export type $QueryParams = {
  id?: null | string;
} & Partial<$CreateParams>;

export type $Associations = {
  Admin?: $Model<'Admin'>;
  Regatta?: $Model<'Regatta'>;
};

export type $ModelParams = $Associations & $CreateParams & {
  id: string;
};

type $Fields = {
  id: string;
};

const fields = (
  Sequelize,
): Record<keyof $Fields, $Field> => ({
  id: {
    allowNull: false,
    defaultValue: Sequelize.UUIDV4,
    primaryKey: true,
    type: Sequelize.UUID,
    unique: true,
  },
});

export default ((
  Sequelize,
  stack,
): $ModelClass<'RegattaAdmin'> => {
  const RegattaAdmin = stack.define(
    'RegattaAdmin',
    fields(Sequelize),
    {
      tableName: 'RegattaAdmins',
    },
  );

  RegattaAdmin.associate = (models: $ModelClasses) => {
    models.RegattaAdmin.belongsTo(
      models.Regatta,
      {
        as: 'Regatta',
        foreignKey: 'RegattaId',
      },
    );
    models.RegattaAdmin.belongsTo(
      models.Admin,
      {
        as: 'Admin',
        foreignKey: 'AdminId',
      },
    );
  };

  return RegattaAdmin;
});
